import { render, staticRenderFns } from "./FloorMapLegend.vue?vue&type=template&id=77635b66"
import script from "./FloorMapLegend.vue?vue&type=script&lang=js"
export * from "./FloorMapLegend.vue?vue&type=script&lang=js"
import style0 from "./FloorMapLegend.vue?vue&type=style&index=0&id=77635b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports